// extracted by mini-css-extract-plugin
export default {"prospectusBacImg":"footer_prospectusBacImg__eLS2d"};